import { render, staticRenderFns } from "./RejectedPartDetail.vue?vue&type=template&id=5ba804ee"
import script from "./RejectedPartDetail.vue?vue&type=script&lang=js"
export * from "./RejectedPartDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports